import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { errorToast } from "../Components/ToastMessage";
import axios from "axios";
import { dispatch } from "../reduxReducers/configureStore";
import { setAuthData } from "../reduxReducers/slices/AuthSLice";

const AuthGuard = ({ children }) => {
  const authToken = localStorage.getItem("authToken");
  const user = useSelector((state) => state.Auth.authData);

  const getUserByToken = useCallback(async () => {
    try {
      const response = await axios.get("/auth/me");
      if (response?.data) {
        dispatch(setAuthData(response.data));
      }
    } catch (error) {
      errorToast(error.message);
    }
  }, []);

  useEffect(() => {
    if (!user && authToken) {
      getUserByToken();
    }
  }, [user, getUserByToken, authToken]);

  if (!authToken) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default AuthGuard;
